import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "61",
  height: "61",
  fill: "none",
  viewBox: "0 0 61 61"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-width": "2"
    }, [
      _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M5.37 1.5h50.27c2.13 0 3.87 1.73 3.87 3.87v50.27c0 2.13-1.73 3.87-3.87 3.87H5.37c-2.13 0-3.87-1.73-3.87-3.87V5.37c0-2.13 1.73-3.87 3.87-3.87Z"
      }),
      _createElementVNode("path", {
        "stroke-miterlimit": "10",
        d: "M30.5 31.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11Z"
      }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M50.47 51.5c-.27-10.01-9.14-19-19.97-19-10.83 0-19.71 8.99-19.97 19h39.95-.01Z"
      })
    ], -1)
  ])))
}
export default { render: render }